import React from "react";
import Skeleton from "../../skeleton";

const Mobile = () => (

	<>
		<div className="card-skeleton-tab-brand">
			<div className="card-skeleton-tab-brand__section-brand">
				<Skeleton
					width="200px"
					height="20px"
				/>
				<div className="card-skeleton-tab-brand__brand">
					{Array.from({ length: 10 }, (value, id) => (
						<div key={id} className="card-skeleton-tab-brand__brand-data">
							<Skeleton
								width="150px"
								height="72px"
							/>
						</div>
					))}
				</div>
				<div className="card-skeleton-tab-brand__brand-button">
					<Skeleton
						width="240px"
						height="40px"
						margin="auto"
					/>
				</div>
			</div>

		</div>
		<style jsx>
			{`
				.card-skeleton-tab-brand{
					max-width: 480px;
				}
				.card-skeleton-tab-brand__section-brand{
					margin-top:12px;
				}
				.card-skeleton-tab-brand__brand {
					display: grid;
					justify-content: space-between;
					margin-top: 18px;
					grid-template-columns: repeat(2, 1fr);
    				gap: 20px;
				}
				.card-skeleton-tab-brand__brand-button{
					margin-top: 41px;
					display: flex;
					align-items: center;
					justify-content: center;
				}
		`}
		</style>
	</>

);

export default Mobile;
